/* eslint-disable */
export default [
  {
    path: "/ecosystem/abtrip",
    name: "abtrip",
    component: () => import(/* webpackChunkName: "ecosystem" */ "@/views/b2c/ABTrip.vue")
  },
  {
    path: "/tiktok-order",
    name: "tiktok-order",
    component: () => import(/* webpackChunkName: "ecosystem" */ "@/views/tiktok/Orders.vue")
  },
  {
    path: "/shopee-order",
    name: "shopee-order",
    component: () => import(/* webpackChunkName: "ecosystem" */ "@/views/shopee/Orders.vue")
  }
];
